import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations, LANGUAGES } from '../i18n/translations';
import { store } from '../lib/localStore';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => store.getLang() || 'en');

  const setLang = useCallback((l) => {
    setLangState(l);
    store.setLang(l);
  }, []);

  const t = useCallback((k) => {
    return (translations[lang] && translations[lang][k]) || translations.en[k] || k;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
